<template>
  <main class="full-height">
    <v-toolbar-side-icon @click.stop="redirectBack">
      <v-icon>arrow_back</v-icon>
    </v-toolbar-side-icon>
    <v-content>
      <v-container fluid grid-list-xl>
        <v-layout justify-center row wrap>
          <v-flex xs12 class="text-xs-center">
            <v-layout row wrap>
              <button
                type="button"
                class="button-return-filters"
                @click="$router.go(-1)"
              >
                <v-icon>arrow_back</v-icon>
              </button>
              <v-flex xs12>
                <h2 class="font-weight-black">Extratos Encontrados</h2>
              </v-flex>

              <v-flex xs12>
                <v-card class="form-card">
                  <div class="layout-excel">
                    <button type="button" v-on:click="download">
                      <img
                        class="img-excel"
                        :src="require('@/assets/excel.png')"
                        alt="Baixar dados em planilha"
                        title="Baixar dados em planilha"
                      />
                    </button>
                  </div>
                  <div class="layout-table">
                    <v-data-table
                      :headers="headers"
                      :items="policies"
                      :pagination.sync="pagination"
                      :rows-per-page-items="[10, 20]"
                      :loading="false"
                      :no-data-text="msgNoResults"
                      :rows-per-page-text="'Linhas por página'"
                      class="elevation-1"
                      id="table"
                    >
                      <template slot="items" slot-scope="props">
                        <tr style="cursor: pointer">
                          <td
                            style="text-align: left;"
                            class="lg-column"
                            @click="
                              routerNewTarget(
                                props.item.cd_proposta,
                                props.item.cd_produto
                              )
                            "
                          >
                            {{ props.item.modalidade.trim() }}
                          </td>

                          <td
                            class="text-left"
                            @click="
                              routerNewTarget(
                                props.item.cd_proposta,
                                props.item.cd_produto
                              )
                            "
                          >
                            {{ props.item.nr_apolice }}
                          </td>

                          <td
                            class="text-left"
                            @click="
                              routerNewTarget(
                                props.item.cd_proposta,
                                props.item.cd_produto
                              )
                            "
                          >
                            {{ props.item.nr_endosso }}
                          </td>

                          <td
                            class="text-left"
                            @click="
                              routerNewTarget(
                                props.item.cd_proposta,
                                props.item.cd_produto
                              )
                            "
                          >
                            {{ props.item.nr_apolice_susep }}
                          </td>

                          <td
                            class="sm-column text-left"
                            @click="
                              routerNewTarget(
                                props.item.cd_proposta,
                                props.item.cd_produto
                              )
                            "
                          >
                            {{ toMoneyString(props.item.valor_is) }}
                          </td>

                          <td
                            class="sm-column text-left"
                            @click="
                              routerNewTarget(
                                props.item.cd_proposta,
                                props.item.cd_produto
                              )
                            "
                          >
                            {{ toMoneyString(props.item.premio) }}
                          </td>

                          <td
                            class="md-column text-left"
                            @click="
                              routerNewTarget(
                                props.item.cd_proposta,
                                props.item.cd_produto
                              )
                            "
                          >
                            {{ addPercent(props.item.porcentagem_comissao) }}
                          </td>

                          <td
                            @click="
                              routerNewTarget(
                                props.item.cd_proposta,
                                props.item.cd_produto
                              )
                            "
                          >
                            {{ formatDate(props.item.dt_emissao) }}
                          </td>

                          <td
                            @click="
                              routerNewTarget(
                                props.item.cd_proposta,
                                props.item.cd_produto
                              )
                            "
                          >
                            {{ formatDate(props.item.inicio_vigencia) }}
                          </td>

                          <td
                            @click="
                              routerNewTarget(
                                props.item.cd_proposta,
                                props.item.cd_produto
                              )
                            "
                          >
                            {{ formatDate(props.item.fim_vigencia) }}
                          </td>

                          <td
                            class="lg-column text-left"
                            @click="
                              routerNewTarget(
                                props.item.cd_proposta,
                                props.item.cd_produto
                              )
                            "
                          >
                            {{ props.item.tomador.toUpperCase() }}
                          </td>

                          <td
                            class="md-column text-left"
                            @click="
                              routerNewTarget(
                                props.item.cd_proposta,
                                props.item.cd_produto
                              )
                            "
                          >
                            {{ formatCNPJAndCPF(props.item.cnpj_tomador) }}
                          </td>

                          <td
                            class="lg-column text-left"
                            @click="
                              routerNewTarget(
                                props.item.cd_proposta,
                                props.item.cd_produto
                              )
                            "
                          >
                            {{ props.item.segurado.toUpperCase() }}
                          </td>

                          <td
                            class="md-column text-left"
                            @click="
                              routerNewTarget(
                                props.item.cd_proposta,
                                props.item.cd_produto
                              )
                            "
                          >
                            {{ formatCNPJAndCPF(props.item.cnpj_cpf_segurado) }}
                          </td>

                          <td
                            @click="
                              routerNewTarget(
                                props.item.cd_proposta,
                                props.item.cd_produto
                              )
                            "
                          >
                            {{ props.item.status }}
                          </td>
                          <td class="sm-column text-center">
                            <button
                              class="button-table"
                              @click="
                                getMinutaOrBoleto(
                                  props.item.cd_produto,
                                  props.item.cd_proposta
                                )
                              "
                            >
                              <v-icon class="icon-table">description</v-icon
                              >Apólice
                            </button>
                          </td>
                          <td class="sm-column text-center">
                            <button
                              class="button-table"
                              @click="
                                getMinutaOrBoleto(
                                  props.item.cd_produto,
                                  props.item.cd_proposta,
                                  2
                                )
                              "
                            >
                              <v-icon class="icon-table">description</v-icon
                              >Boleto
                            </button>
                          </td>
                        </tr>
                      </template>

                      <v-alert
                        slot="no-results"
                        :value="true"
                        color="error"
                        icon="warning"
                      >
                        Sua pesquisa por "{{}}" não encontrou resultados.
                      </v-alert>
                    </v-data-table>
                  </div>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </main>
</template>

<script>
import ViewMixin from "@/mixins/ViewMixin";
import {
  formatDate,
  toMoneyString,
  addPercent,
  formatCNPJAndCPF,
} from "@/libs/utils";
import XLSX from "xlsx";

export default {
  name: "ExtratosListar",
  mixins: [ViewMixin],
  data: () => ({
    formatDate,
    toMoneyString,
    addPercent,
    formatCNPJAndCPF,
    XLSX,
    json_name_xls: null,
    json_data_format: null,
    policies: [],
    pagination: {},
    loaded: true,
    me: {},
    msgNoResults: "Nenhum extrato encontrado para os filtros selecionados",
    headers: [
      {
        text: "Produto",
        align: "left",
        sortable: false,
      },
      {
        text: "Número da Apólice",
        align: "left",
        sortable: false,
      },
      {
        text: "Número Endosso",
        align: "left",
        sortable: false,
      },
      {
        text: "Número Apólice SUSEP",
        align: "left",
        sortable: false,
      },
      {
        text: "Valor da IS",
        align: "left",
        sortable: false,
      },
      {
        text: "Prêmio",
        align: "left",
        sortable: false,
      },
      {
        text: "Comissão - %",
        align: "left",
        sortable: false,
      },
      {
        text: "Data da Emissão",
        align: "center",
        sortable: false,
      },
      {
        text: "Início de Vigência",
        align: "center",
        sortable: false,
      },
      {
        text: "Final de Vigência",
        align: "center",
        sortable: false,
      },
      {
        text: "Nome do Tomador",
        align: "left",
        sortable: false,
      },
      {
        text: "CNPJ do Tomador",
        align: "left",
        sortable: false,
      },
      {
        text: "Nome do Segurado",
        align: "left",
        sortable: false,
      },
      {
        text: "CPF/CNPJ do Segurado",
        align: "left",
        sortable: false,
      },
      {
        text: "Status Atual da Apólice",
        align: "left",
        sortable: false,
      },
      {
        text: "Apólice",
        align: "center",
        sortable: false,
      },
      {
        text: "Boleto",
        align: "center",
        sortable: false,
      },
    ],
  }),
  methods: {
    init() {
      Promise.all([this.getTickets()]);
      this.loaded = true;
    },

    async getTickets() {
      try {
        this.showLoadingIndicator();
        const me = await this.$store.dispatch("GET_ME");
        this.policies = await this.$store.dispatch("GET_EXTRATOS", {
          document: me.company.document,
        });
        this.me = me;
        if (this.policies.length === 0) {
          this.setErrorModal(this.$strings.noExtractsFound);
        }
      } catch (e) {
        this.setErrorModal(this.$strings.defaultOperationError);
      } finally {
        this.hideLoadingIndicator();
      }
    },

    prepareJSONForExcel(data) {
      this.json_name_xls = `${
        this.me.company.document
      }-${new Date().toISOString().substr(0, 10)}`;
      this.json_data_format = data.map((item) => {
        return {
          "Produto": item.modalidade,
          "Número da apólice": item.nr_apolice,
          "Número endosso": item.nr_endosso,
          "Número apólice SUSEP": item.nr_apolice_susep,
          "Valor da IS": parseFloat(item.valor_is),
          "Prêmio": parseFloat(item.premio),
          "Comissão - %": this.addPercent(item.porcentagem_comissao),
          "Data da emissão": this.formatDate(item.dt_emissao),
          "Início de vigência": this.formatDate(item.inicio_vigencia),
          "Final de vigência": this.formatDate(item.fim_vigencia),
          "Nome do tomador": item.tomador.toUpperCase(),
          "CNPJ tomador": this.formatCNPJAndCPF(item.cnpj_tomador),
          "Nome do segurado": item.segurado.toUpperCase(),
          "CNPJ/CPF segurado": this.formatCNPJAndCPF(item.cnpj_cpf_segurado),
          "Status atual da apólice": item.status.toUpperCase(),
        };
      });
    },

    download() {
      this.prepareJSONForExcel(this.policies);
      const data = XLSX.utils.json_to_sheet(this.json_data_format);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, data, "data");
      XLSX.writeFile(wb, `${this.json_name_xls}.xlsx`);
    },

    async getMinutaOrBoleto(id_produto, id_proposta, tipo = 1) {
      let payload = {
        id_produto,
        id_proposta,
      };

      if (tipo == 1) {
        this.showLoadingAskWait();
        try {
          await this.$store.dispatch("GET_MINUTA", payload);
        } catch (e) {
          e.response.data = {
            code: 5013,
            message: "Não foi possível gerar a minuta da proposta.",
            title: "Minuta não disponível",
          };
          this.defaultHandlerError(e);
          return;
        } finally {
          this.hideLoadingAskWait();
        }
      } else if (tipo == 2) {
        this.showLoadingIndicator();
        try {
          await this.$store.dispatch("GET_BOLETO", payload);
        } catch (e) {
          e.response.data = {
            code: 5013,
            message: "Não foi possível gerar o boleto da proposta.",
            title: "Boleto não disponível",
          };
          this.defaultHandlerError(e);
        } finally {
          this.hideLoadingIndicator();
        }
      }
    },

    routerNewTarget(cd_proposta, cd_produto) {
      let router = this.$router.resolve({
        path: `/proposta/${cd_proposta}/${cd_produto}`,
      });
      let href = router.href;
      window.open(href, "_blank");
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style lang="scss" scoped>
#jns {
  .full-height {
    .container {
      padding: 0 40px;
    }

    .v-content {
      padding: 50px 0 0 80px !important;
    }
  }

  .button-return-filters {
    transition: all 0.3s;
    position: absolute;
    border-radius: 50%;
    background-color: #f1e41e;

    i {
      padding: 5px;
      font-size: 2rem;
      color: #061d45;
    }

    &:hover {
      background-color: #061d45;

      i {
        color: #fff;
      }
    }
  }

  @media (max-width: 480px) {
    .button-return-filters {
      position: relative;
    }
  }

  .form-card {
    .layout-excel {
      display: flex;
      width: 100%;
      height: 70px;
      align-items: center;
      justify-content: flex-end;
      border-bottom: 1px solid #ddd;
      .img-excel {
        width: 35px;
        margin: 5px 2rem 0 0;
      }
    }

    .layout-table {
      height: auto;
      max-height: 620px;
      overflow: auto;

      #table {
        overflow: auto;

        .button-table {
          display: flex;
          width: 120px;
          border-radius: 32px;
          height: 32px;
          background-color: #061d45;
          color: #fff;
          align-items: center;
          justify-content: center;
          font-weight: bold;
          transition: all 0.5s;

          .icon-table {
            color: #fff;
            margin-right: 5px;
          }
        }

        .button-table:hover {
          background-color: #fff;
          color: #061d45;

          .icon-table {
            color: #061d45;
          }
        }

        .text-left {
          text-align: left;
        }

        .text-center {
          text-align: center;
        }

        .sm-column {
          min-width: 150px;
          width: 150px;
          max-width: 200px;
        }

        .md-column {
          min-width: 200px;
          width: 250px;
          max-width: 350px;
        }

        .lg-column {
          min-width: 400px;
          width: 400px;
          max-width: 500px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// ./src/router/views/ExtratosRecibos/ExtratosEmissaoProducao/Listar.vue